/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';

import moQuestion, { changeQuestion, changeFive } from '../store';
import '../scss/common.scss';
import {
  BorderLinearProgress,
  DInput,
  NextButton,
  PrevButton,
} from '@/styled/button';
import { submitQuestion } from '@/styled/common';
import { isEmpty } from 'lodash';
import QuestionService from '@/service/question';
import { observer } from 'mobx-react';

const FiveQuestion = (props: any) => {
  const [type, setType] = useState('question');
  const [list1, setList1] = useState<any>([]);
  const [list2, setList2] = useState<any>([]);
  const [list3, setList3] = useState<any>([]);
  const [market, setMarket] = useState<any>({});
  const [show, setShow] = useState<any>(false);
  const { fiveAnswer, prevtime } = moQuestion;
  const onSave = async () => {
    const result = await submitQuestion(
      `${prevtime}年，不同绩效员工调薪率`,
      fiveAnswer,
      prevtime,
    );
    if (!isEmpty(result)) {
      const res1: any = [
        {
          name: '25分位',
          all:
            result.one && result.one.p25 ? `${result.one.p25}%` : '-',
          hight:
            result.two && result.two.p25 ? `${result.two.p25}%` : '-',
          manege:
            result.three && result.three.p25 ?
              `${result.three.p25}%` :
              '-',
          just:
            result.four && result.four.p25 ?
              `${result.four.p25}%` :
              '-',
        },
        {
          name: '50分位',
          all:
            result.one && result.one.p50 ? `${result.one.p50}%` : '-',
          hight:
            result.two && result.two.p50 ? `${result.two.p50}%` : '-',
          manege:
            result.three && result.three.p50 ?
              `${result.three.p50}%` :
              '-',
          just:
            result.four && result.four.p50 ?
              `${result.four.p50}%` :
              '-',
        },
        {
          name: '75分位',
          all:
            result.one && result.one.p75 ? `${result.one.p75}%` : '-',
          hight:
            result.two && result.two.p75 ? `${result.two.p75}%` : '-',
          manege:
            result.three && result.three.p75 ?
              `${result.three.p75}%` :
              '-',
          just:
            result.four && result.four.p75 ?
              `${result.four.p75}%` :
              '-',
        },
        {
          name: '平均值',
          all:
            result.one && result.one.avg ? `${result.one.avg}%` : '-',
          hight:
            result.two && result.two.avg ? `${result.two.avg}%` : '-',
          manege:
            result.three && result.three.avg ?
              `${result.three.avg}%` :
              '-',
          just:
            result.four && result.four.avg ?
              `${result.four.avg}%` :
              '-',
        },
      ];
      const res2 = [
        {
          name: '25分位',
          all:
            result.five && result.five.p25 ?
              `${result.five.p25}%` :
              '-',
          hight:
            result.six && result.six.p25 ? `${result.six.p25}%` : '-',
          manege:
            result.seven && result.seven.p25 ?
              `${result.seven.p25}%` :
              '-',
          just:
            result.eight && result.eight.p25 ?
              `${result.eight.p25}%` :
              '-',
        },
        {
          name: '50分位',
          all:
            result.five && result.five.p50 ?
              `${result.five.p50}%` :
              '-',
          hight:
            result.six && result.six.p50 ? `${result.six.p50}%` : '-',
          manege:
            result.seven && result.seven.p50 ?
              `${result.seven.p50}%` :
              '-',
          just:
            result.eight && result.eight.p50 ?
              `${result.eight.p50}%` :
              '-',
        },
        {
          name: '75分位',
          all:
            result.five && result.five.p75 ?
              `${result.five.p75}%` :
              '-',
          hight:
            result.six && result.six.p75 ? `${result.six.p75}%` : '-',
          manege:
            result.seven && result.seven.p75 ?
              `${result.seven.p75}%` :
              '-',
          just:
            result.eight && result.eight.p75 ?
              `${result.eight.p75}%` :
              '-',
        },
        {
          name: '平均值',
          all:
            result.five && result.five.avg ?
              `${result.five.avg}%` :
              '-',
          hight:
            result.six && result.six.avg ? `${result.six.avg}%` : '-',
          manege:
            result.seven && result.seven.avg ?
              `${result.seven.avg}%` :
              '-',
          just:
            result.eight && result.eight.avg ?
              `${result.eight.avg}%` :
              '-',
        },
      ];
      const res3 = [
        {
          name: '25分位',
          all:
            result.nine && result.nine.p25 ?
              `${result.nine.p25}%` :
              '-',
          hight:
            result.ten && result.ten.p25 ? `${result.ten.p25}%` : '-',
          manege:
            result.eleven && result.eleven.p25 ?
              `${result.eleven.p25}%` :
              '-',
          just:
            result.twelve && result.twelve.p25 ?
              `${result.twelve.p25}%` :
              '-',
        },
        {
          name: '50分位',
          all:
            result.nine && result.nine.p50 ?
              `${result.nine.p50}%` :
              '-',
          hight:
            result.ten && result.ten.p50 ? `${result.ten.p50}%` : '-',
          manege:
            result.eleven && result.eleven.p50 ?
              `${result.eleven.p50}%` :
              '-',
          just:
            result.twelve && result.twelve.p50 ?
              `${result.twelve.p50}%` :
              '-',
        },
        {
          name: '75分位',
          all:
            result.nine && result.nine.p75 ?
              `${result.nine.p75}%` :
              '-',
          hight:
            result.ten && result.ten.p75 ? `${result.ten.p75}%` : '-',
          manege:
            result.eleven && result.eleven.p75 ?
              `${result.eleven.p75}%` :
              '-',
          just:
            result.twelve && result.twelve.p75 ?
              `${result.twelve.p75}%` :
              '-',
        },
        {
          name: '平均值',
          all:
            result.nine && result.nine.avg ?
              `${result.nine.avg}%` :
              '-',
          hight:
            result.ten && result.ten.avg ? `${result.ten.avg}%` : '-',
          manege:
            result.eleven && result.eleven.avg ?
              `${result.eleven.avg}%` :
              '-',
          just:
            result.twelve && result.twelve.avg ?
              `${result.twelve.avg}%` :
              '-',
        },
      ];
      setList1(res1);
      setList2(res2);
      setList3(res3);
    }
    setType('answer');
  };

  useEffect(() => {
    QuestionService.getMarketInfo({
      question: `${prevtime}年，不同绩效员工调薪率`,
      year: prevtime,
    }).then((res: any) => {
      setMarket(res);
    });
    return () => {};
  }, []);

  return (
    <section className='allQuestion'>
      {type === 'question' ? (
        <section className='allContent'>
          <h2>一、调薪率</h2>
          <h3>1.5 {prevtime}年，不同绩效员工调薪率%</h3>
          <section className='commonHead'>
            <b>总体（%）</b>
            <b>高管（%）</b>
            <b>经理及主管（%）</b>
            <b>普通员工（%）</b>
          </section>
          <p className='commonTitle'>
            绩效高于预期<span>（如果不区分级别，则只提供总体数据）</span>
          </p>
          <section className='commonEdit'>
            <DInput
              value={fiveAnswer.one}
              onChange={(e: any) => {
                if (
                  (market?.one?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.one?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'one');
              }}/>
            <DInput
              value={fiveAnswer.two}
              onChange={(e: any) => {
                if (
                  (market?.two?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.two?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'two');
              }}/>
            <DInput
              value={fiveAnswer.three}
              onChange={(e: any) => {
                if (
                  (market?.three?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.three?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'three');
              }}/>
            <DInput
              value={fiveAnswer.four}
              onChange={(e: any) => {
                if (
                  (market?.four?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.four?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'four');
              }}/>
          </section>
          <p className='commonTitle'>绩效达到预期</p>
          <section className='commonEdit'>
            <DInput
              value={fiveAnswer.five}
              onChange={(e: any) => {
                if (
                  (market?.five?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.five?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'five');
              }}/>
            <DInput
              value={fiveAnswer.six}
              onChange={(e: any) => {
                if (
                  (market?.six?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.six?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'six');
              }}/>
            <DInput
              value={fiveAnswer.seven}
              onChange={(e: any) => {
                if (
                  (market?.seven?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.seven?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'seven');
              }}/>
            <DInput
              value={fiveAnswer.eight}
              onChange={(e: any) => {
                if (
                  (market?.eight?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.eight?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'eight');
              }}/>
          </section>
          <p className='commonTitle'>绩效低于预期</p>
          <section className='commonEdit'>
            <DInput
              value={fiveAnswer.nine}
              onChange={(e: any) => {
                if (
                  (market?.nine?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.nine?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'nine');
              }}/>
            <DInput
              value={fiveAnswer.ten}
              onChange={(e: any) => {
                if (
                  (market?.ten?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.ten?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'ten');
              }}/>
            <DInput
              value={fiveAnswer.eleven}
              onChange={(e: any) => {
                if (
                  (market?.eleven?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.eleven?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'eleven');
              }}/>
            <DInput
              value={fiveAnswer.twelve}
              onChange={(e: any) => {
                if (
                  (market?.twelve?.p75 &&
                    Number(
                      e.target.value.replace(
                        /^\D*([0-9]\d*\.?\d{0,2})?.*$/,
                        '$1',
                      ),
                    ) * 2) > market?.twelve?.p75
                ) {
                  setShow(true);
                } else {
                  setShow(false);
                }
                changeFive(e.target.value, 'twelve');
              }}/>
          </section>
          {show && (
            <p className='prompt'>
              *填写的数据，大幅超过市场值，请检查！
            </p>
          )}
        </section>
      ) : (
        <section className='allContent'>
          <h2>一、调薪率</h2>
          <h3>1.5 {prevtime + 1}年，不同绩效员工调薪率统计结果</h3>
          <section className='commonHead'>
            <b>分布</b>
            <b>总体</b>
            <b>高管</b>
            <b>经理及主管</b>
            <b>普通员工</b>
          </section>
          <p className='commonTitle'>绩效高于预期</p>
          {list1?.map((res: any) => {
            return (
              <section className='commonShow' key={res.name}>
                <b>{res.name}</b>
                <b>{res.all}</b>
                <b>{res.hight}</b>
                <b>{res.manege}</b>
                <b>{res.just}</b>
              </section>
            );
          })}
          <p className='commonTitle'>绩效达到预期</p>
          {list2?.map((res: any) => {
            return (
              <section className='commonShow' key={res.name}>
                <b>{res.name}</b>
                <b>{res.all}</b>
                <b>{res.hight}</b>
                <b>{res.manege}</b>
                <b>{res.just}</b>
              </section>
            );
          })}
          <p className='commonTitle'>绩效低于预期</p>
          {list3?.map((res: any) => {
            return (
              <section className='commonShow' key={res.name}>
                <b>{res.name}</b>
                <b>{res.all}</b>
                <b>{res.hight}</b>
                <b>{res.manege}</b>
                <b>{res.just}</b>
              </section>
            );
          })}
        </section>
      )}
      <section className='btnGroup'>
        <section className='numProgress'>
          <p className='num'>
            <span>5</span> / 15
          </p>
          <BorderLinearProgress variant='determinate' value={(5 / 15) * 100} />
        </section>
        <PrevButton
          onClick={() => {
            changeQuestion(4);
          }}>
          上一题
        </PrevButton>
        {type === 'question' ? (
          <PrevButton
            onClick={() => {
              changeQuestion(6);
            }}>
            跳过此题
          </PrevButton>
        ) : (
          <PrevButton
            onClick={() => {
              setType('question');
            }}>
            重新填写
          </PrevButton>
        )}
        {type === 'question' ? (
          <NextButton
            onClick={onSave}
            disabled={
              !fiveAnswer.one &&
              !fiveAnswer.two &&
              !fiveAnswer.three &&
              !fiveAnswer.four &&
              !fiveAnswer.one &&
              !fiveAnswer.two &&
              !fiveAnswer.three &&
              !fiveAnswer.four &&
              !fiveAnswer.one &&
              !fiveAnswer.two &&
              !fiveAnswer.three &&
              !fiveAnswer.four
            }>
            保存查看结果
          </NextButton>
        ) : (
          <NextButton
            onClick={() => {
              changeQuestion(6);
            }}>
            下一题
          </NextButton>
        )}
      </section>
    </section>
  );
};

export default observer(FiveQuestion);
